import React, { useCallback, useContext } from 'react'
import ModalContext from 'contexts/ModalContext'
import useHashSignal from 'hooks/useHashSignal'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import TasteOfGoldLearnMoreModal from '../components/TasteOfGoldLearnMoreModal'

const TASTE_OF_GOLD_HASH = '#taste-of-gold' as const

function useTasteOfGoldHashModal() {
  const showModal = useContext(ModalContext)
  const loggedIn = useAppSelector(selectLoggedIn)

  const openTasteOfGoldModal = useCallback(() => {
    if (loggedIn) {
      showModal(React.createElement(TasteOfGoldLearnMoreModal))
    } else {
      showModal<AccountAccessModalResult>(
        React.createElement(AccountAccessModal, { initialMode: 'login' }),
      ).then(result => {
        if (result?.loggedIn) {
          showModal(React.createElement(TasteOfGoldLearnMoreModal))
        }
      })
    }
  }, [loggedIn, showModal])

  const { clearHash } = useHashSignal({
    hash: TASTE_OF_GOLD_HASH,
    onActivate: openTasteOfGoldModal,
  })

  return { clearHash }
}

export default useTasteOfGoldHashModal
